<template>
  <div
    class="gw_clrpckr"
    style="--width: var(--clrpickr-menu-width)"
  >
    <v-color-picker
      v-if="hasColorPicker"
      style="width: 100%; height: 100%"
      light
      dot-size="18"
      :input="updateHex"
      :model-value="value"
      mode="hexa"
    ></v-color-picker>

    <div class="gw_clrpckr_clrs">
      <div
        v-for="hex in colors"
        :key="hex"
        class="gw_clrpckr_clrsr_box gw_btn"
        :title="hex"
        :style="`
            --clr-back:${hex};

          `"
        style="--brighten-hover: 0.35; --width: 1.5rem; padding: 0; --height: 1.5rem"
        @click="updateHex(hex)"
      >
        <i
          v-if="value === hex || values.includes(hex)"
          class="mdi mdi-check-circle text-normal line-height_1 position-absolute"
        ></i>
      </div>
    </div>
    <slot> </slot>
  </div>
</template>

<script>
import { getLabelColors } from '@/helpers/constants'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'GwColorPicker',
  mixins: [float_mix],
  props: {
    values: { type: Array, default: () => [] },
    value: { default: '#FFFFFF' },
    hasColorPicker: { default: false },
    hasColors: { default: false },
    colors: { type: Array, default: () => getLabelColors() },
  },
  emits: ['update:hex'],
  data() {
    return {}
  },
  methods: {
    updateHex(hex) {
      this.$emit('update:hex', hex)
    },
  },
}
</script>
<style lang="scss" scoped>
.gw_clrpckr {
  // color: #f25c57;
  // color: #e97852;
  // color: #e5b466;
  // color: #ebcb44;
  // color: #b1d14d;
  // color: #569976;
  // color: #5abeb9;
  // color: #8dcac7;
  // color: #3761be;
  // color: #6964ec;
  // color: #a05bcd;
  // color: #ef99eb;
  &_clrs {
    width: 100%;
    display: grid;
    gap: 0.25rem;
    grid-template-columns: repeat(6, 1fr);
    flex-shrink: 0;
    &_box {
      --clr-back: red;
      border-radius: 4px;
      background: var(--clr-back);
    }
  }
}
</style>
